<ag-contact-history
  [service]="companyApiService"
  [referenceId]="companyId"
></ag-contact-history>
